import { useNavigate } from 'react-router-dom';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { AdvertiseLayout } from '@/components/advertise/AdvertiseLayout';
import { AdvertiseSideSummary } from '@/components/advertise/AdvertiseSideSummary';
import { AdvertiseFooterNav } from '@/components/advertise/AdvertiseFooterNav';
import { useAdvertise } from '@/store/useAdvertise';
import { useStepGuard, agentsStepValid } from '@/utils/advertiseGuards';
import { AGENTS_STEPS } from '@/config/advertiseSteps';

export default function AgentsProfile() {
  const navigate = useNavigate();
  const agents = useAdvertise((s) => s.agents);
  const setField = useAdvertise((s) => s.setField);
  useStepGuard(agentsStepValid.profile(agents), '/advertise/agents');

  const set = (patch) => setField('agents', patch);
  const canProceed = agents.firstName && agents.lastName && agents.email && agents.phone && agents.zip;

  return (
    <AdvertiseLayout
      trackLabel="Agent advertising"
      steps={AGENTS_STEPS}
      currentStepId="profile"
      title="Tell us about you"
      subtitle="We\u2019ll use this to set up your account and reach out."
      sidebar={
        <AdvertiseSideSummary
          items={[
            { label: 'Name', value: [agents.firstName, agents.lastName].filter(Boolean).join(' ') },
            { label: 'Company', value: agents.company },
            { label: 'Office ZIP', value: agents.zip },
          ]}
        />
      }
      footer={<AdvertiseFooterNav nextDisabled={!canProceed} onBack={() => navigate('/advertise/agents/plan')} onNext={() => navigate('/advertise/agents/goals')} />}
    >
      <div className="grid gap-4 sm:grid-cols-2">
        <div><Label>First name</Label><Input value={agents.firstName} onChange={(e) => set({ firstName: e.target.value })} className="mt-1.5 rounded-xl" data-testid="agents-profile-first-name" /></div>
        <div><Label>Last name</Label><Input value={agents.lastName} onChange={(e) => set({ lastName: e.target.value })} className="mt-1.5 rounded-xl" data-testid="agents-profile-last-name" /></div>
        <div className="sm:col-span-2"><Label>Email</Label><Input type="email" value={agents.email} onChange={(e) => set({ email: e.target.value })} className="mt-1.5 rounded-xl" data-testid="agents-profile-email" /></div>
        <div><Label>Company / brokerage</Label><Input value={agents.company} onChange={(e) => set({ company: e.target.value })} className="mt-1.5 rounded-xl" data-testid="agents-profile-company" /></div>
        <div><Label>Phone</Label><Input type="tel" value={agents.phone} onChange={(e) => set({ phone: e.target.value })} className="mt-1.5 rounded-xl" data-testid="agents-profile-phone" /></div>
        <div><Label>Office ZIP</Label><Input value={agents.zip} onChange={(e) => set({ zip: e.target.value })} className="mt-1.5 rounded-xl" data-testid="agents-profile-zip" /></div>
        <div><Label>MLS ID <span className="text-slate-400 font-normal">(optional)</span></Label><Input value={agents.mlsId} onChange={(e) => set({ mlsId: e.target.value })} className="mt-1.5 rounded-xl" data-testid="agents-profile-mls-id" /></div>
      </div>
    </AdvertiseLayout>
  );
}
